import { render } from "./ProfilePosts.vue?vue&type=template&id=2db1cd5a"
import script from "./ProfilePosts.vue?vue&type=script&lang=js"
export * from "./ProfilePosts.vue?vue&type=script&lang=js"
script.render = render

export default script